// frontend/src/livequiz/AnimatedNumber.js
import React, { useEffect, useState, useRef } from 'react';

/**
 * Animates a number counting up/down to its target value whenever it changes.
 * Usage: <AnimatedNumber value={entry.total_score} />
 */
const AnimatedNumber = ({ value, duration = 500 }) => {
    const [displayValue, setDisplayValue] = useState(value);
    const prevValue = useRef(value);
    const frameRef = useRef(null);

    useEffect(() => {
        const start = prevValue.current;
        const end = value;
        if (start === end) return;

        const startTime = performance.now();

        const animate = (now) => {
            const elapsed = now - startTime;
            const progress = Math.min(elapsed / duration, 1);
            const current = Math.round(start + (end - start) * progress);
            setDisplayValue(current);

            if (progress < 1) {
                frameRef.current = requestAnimationFrame(animate);
            } else {
                prevValue.current = end;
            }
        };

        frameRef.current = requestAnimationFrame(animate);

        return () => {
            if (frameRef.current) cancelAnimationFrame(frameRef.current);
        };
    }, [value, duration]);

    return <span>{displayValue}</span>;
};

export default AnimatedNumber;